import type { ServiceError, SubscriptionExpanded } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWR from "swr";

const useSubscriptionDB = () => {
	const { userId } = useAuth();

	const {
		data: subscriptionDB,
		isLoading,
		mutate: refreshSubscriptionDB,
		error,
		isValidating,
	} = useSWR<SubscriptionExpanded | null, ServiceError>(
		userId && "/subscription",
		{
			// Membership can change after checkout / webhooks — do not freeze a
			// null/error forever the way useSWRImmutable would.
			revalidateOnFocus: true,
			errorRetryCount: 2,
		},
	);

	return {
		subscriptionDB,
		isLoading,
		isValidating,
		refreshSubscriptionDB,
		error,
	};
};

export default useSubscriptionDB;
